import * as React from 'react';
import { css, cx } from '@emotion/css';
import { cn } from '@src/lib/utils';

export interface FlexProps extends React.HTMLAttributes<HTMLDivElement> {
    vertical?: boolean;
    align?: 'start' | 'center' | 'end' | 'stretch';
    justify?: 'start' | 'center' | 'end' | 'space-between' | 'space-around' | 'space-evenly';
    gap?: number | string;
    wrap?: boolean;
}

export const Flex = React.forwardRef<HTMLDivElement, FlexProps>(
    ({ vertical, align, justify, gap, wrap, className, style, ...props }, ref) => {
        const gapValue = typeof gap === 'number' ? `${gap}px` : gap || '0px';

        return (
            <div
                ref={ref}
                style={style}
                className={cn(
                    css`
                        display: flex;
                        flex-direction: ${vertical ? 'column' : 'row'};
                        align-items: ${align === 'start' ? 'flex-start' : align === 'end' ? 'flex-end' : align === 'stretch' ? 'stretch' : 'center'};
                        justify-content: ${justify === 'start' ? 'flex-start' : justify === 'end' ? 'flex-end' : justify === 'space-between' ? 'space-between' : justify === 'space-around' ? 'space-around' : justify === 'space-evenly' ? 'space-evenly' : 'center'};
                        gap: ${gapValue};
                        flex-wrap: ${wrap ? 'wrap' : 'nowrap'};
                    `,
                    className
                )}
                {...props}
            />
        );
    }
);

Flex.displayName = 'Flex';

